<template>
    <section>
        <product-renderer />

        <button
            @click="toggleFullscreen"
            class="absolute top-10 right-10 rounded-full h-12 w-12 hidden lg:flex justify-center items-center bg-white"
        >
            <img
                src="../assets/images/icons/expand.svg"
                width="18"
                height="18"
                alt="Expand"
            >
        </button>

        <help-button class="absolute bottom-4 left-6 md:left-11 lg:bottom-5 lg:left-10 md:h-11" />

        <div class="absolute bottom-4 right-6 md:right-11 lg:bottom-5 lg:right-10 flex gap-8">
            <undo-button class="md:h-11" />

            <share-button class="md:h-11" />
        </div>
    </section>
</template>

<script>
    import allStores from '../stores/all';

    import ProductRenderer from './ProductRenderer.vue';
    import HelpButton from './HelpButton.vue';
    import UndoButton from './UndoButton.vue';
    import ShareButton from './ShareButton.vue';

    export default {
        mixins: [allStores],

        components: {
            ProductRenderer,
            HelpButton,
            UndoButton,
            ShareButton,
        },

        computed: {
            isFullscreen() {
                return this.appStore.isFullscreen;
            },
        },

        methods: {
            toggleFullscreen() {
                let newSize = false;

                if (!this.isFullscreen) {
                    newSize = true;
                }

                this.appStore.setIsFullscreen(newSize);
            },
        },
    };
</script>
